module.exports = __webpack_public_path__ + "static/c_miiii-30861e089bd84aecb76e4c265407f8bc.jpeg";